import { styled, Paper } from "@mui/material";

export const ProChip = styled(Paper)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  overflow: "hidden",
  transition: "all 0.3s ease",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "200%",
    height: "200%",
    background: `linear-gradient(
      45deg,
      transparent 30%,
      rgba(255,255,255,0.3) 50%,
      transparent 70%
    )`,
    transform: "translateX(-100%) translateY(-100%) rotate(30deg)",
    animation: "autoShine 2s ease-in-out infinite",
    zIndex: 1,
  },

  "@keyframes autoShine": {
    "0%": {
      transform: "translateX(-100%) translateY(-100%) rotate(30deg)",
    },
    "50%": {
      transform: "translateX(0%) translateY(0%) rotate(30deg)",
    },
    "100%": {
      transform: "translateX(100%) translateY(100%) rotate(30deg)",
    },
  },
  "@keyframes hoverShine": {
    "0%": {
      transform: "translateX(-100%) translateY(-100%) rotate(30deg)",
    },
    "100%": {
      transform: "translateX(100%) translateY(100%) rotate(30deg)",
    },
  },
});

export const ClickableProChip = styled(ProChip)({
  "&:hover": {
    transform: "scale(1.08)",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "200%",
      height: "200%",
      background: `linear-gradient(
        45deg,
        transparent 30%,
        rgba(255,255,255,0.7) 50%,
        transparent 70%
      )`,
      transform: "translateX(-100%) translateY(-100%) rotate(30deg)",
      animation: "hoverShine 0.6s ease-in-out",
      zIndex: 2,
    },
  },
});
